module.exports = __webpack_public_path__ + "img/bar-line-chart.a49344ef.svg";